"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CandidateJobsContract = void 0;
/* eslint-disable perfectionist/sort-objects */
const core_1 = require("@ts-rest/core");
const schemas_1 = require("../../../schemas");
const jobs_request_1 = require("./jobs.request");
const jobs_response_1 = require("./jobs.response");
const saved_1 = require("./saved");
const c = (0, core_1.initContract)();
exports.CandidateJobsContract = c.router({
    findById: {
        method: 'GET',
        path: '/jobs/:jobId',
        pathParams: jobs_request_1.JobIdPathParamsSchema,
        responses: {
            200: jobs_response_1.JobDetailResponseSchema,
            404: schemas_1.BaseErrorResponseSchema,
        },
    },
    search: {
        method: 'GET',
        path: '/jobs',
        query: jobs_request_1.JobSearchQuerySchema,
        responses: {
            200: jobs_response_1.JobSearchResponseSchema,
            400: schemas_1.BaseErrorResponseSchema,
        },
    },
    apply: {
        method: 'POST',
        body: schemas_1.EmptyBodySchema,
        path: '/jobs/:jobId/applications',
        pathParams: jobs_request_1.JobIdPathParamsSchema,
        responses: {
            200: schemas_1.BaseResponseSchema,
            400: schemas_1.BaseErrorResponseSchema,
            404: schemas_1.BaseErrorResponseSchema,
        },
    },
    favorite: saved_1.CandidateSavedJobsContract,
});
